import {Component, EventEmitter, Input, OnInit, Output, ViewChild} from '@angular/core';

@Component({
  selector: 'sb-bool-operator',
  templateUrl: './sb-bool-operator.component.html',
  styleUrls: ['./sb-bool-operator.component.scss'],
  standalone: false,
})
export class SbBoolOperatorComponent implements OnInit {
  @Input() operator: string;
  @Output() optionSelected: EventEmitter<string> = new EventEmitter();

  @ViewChild('thedropdown') dropdownchild?: any;

  visible: boolean = false;

  blur: boolean = true;

  options: string[];

  @Input()
  disabled: boolean = false;

  constructor() {}

  ngOnInit() {
    if (!this.options) {
      this.options = ['delete'];
      if (this.operator === '&') {
        this.options.push('|');
      }
      if (this.operator === '|') {
        this.options.push('&');
      }
    }
  }

  onClick(option: string) {
    if (!this.disabled) {
      if (option) {
        this.optionSelected.emit(option);
      }

      this.blur = true;

      this.hide();
    }
  }

  show() {
    // this.visible = true;
  }

  hide() {
    if (this.blur) {
      this.visible = false;
    }
  }

  preventBlur() {
    this.blur = false;
  }

  click($event) {
    if (!this.disabled) {
      this.visible = !this.visible;

      if (this.visible) {
        setTimeout(() => {
          this.dropdownchild.nativeElement.focus();
        }, 1);

        this.blur = true;
      }
    }
  }
}
